import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AdminUser } from 'components/admin/team-members/types/user'

interface AdminUserState {
  users: AdminUser[]
  isLoading: boolean
  error: null
}

const initialState: AdminUserState = {
  users: [],
  isLoading: false,
  error: null
}

const slice = createSlice({
  name: 'admin-users',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },

    // GET Purpose Types
    getAllAdminUsers(state, action: PayloadAction<AdminUser[]>) {
      state.isLoading = false
      state.users = action.payload
      state.error = null
    },
    addNewUserDetails(state, action: PayloadAction<AdminUser>) {
      state.isLoading = false
      const newUsers = Array.isArray(action.payload) ? action.payload : [action.payload]
      state.users = [...(state.users || []), ...newUsers] // Append new details
      state.error = null
    },
    amendUserDetails(
      state,
      action: PayloadAction<{
        individualIdentifier: string
        email?: string,
        roles: Array<string>,
        activeStatus: string,
        communicationPref: string
      }>
    ) {
      state.isLoading = false
      state.users = state.users.map((user) =>
        user?.individualIdentifier === action.payload.individualIdentifier
          ? {
            ...user,
            email: action.payload.email ? action.payload.email : user.email, // Update email
            communicationPref: action.payload.communicationPref,
            roles: action.payload.roles ? action.payload.roles : user.roles, // Update roles
            activeStatus: action.payload.activeStatus === 'DEACTIVATE' ? 'INACTIVE': 'ACTIVE'
          }
          : user
      )
      state.error = null
    },
    clearAllAdminCreateActions(state) {
      state.isLoading = false
      state.users = []
      state.error = null
    }
  }
})

// Reducer
export const {
  getAllAdminUsers,
  hasError,
  startLoading,
  clearAllAdminCreateActions,
  addNewUserDetails,
  amendUserDetails
} = slice.actions
export default slice.reducer
